import { FC } from 'react';
import {
  getCoreRowModel,
  type OnChangeFn,
  type PaginationState,
  type Row,
  type SortingState,
  useReactTable,
} from '@tanstack/react-table';

import { DataTable } from '@/components/table/data-table';
import { useScenariosTableColumns } from '@/routes/(app)/(scenarios)/hooks/use-scenarios-table-columns';
import type { Scenario } from '@/routes/(app)/(scenarios)/types';

interface ScenariosTableProps {
  scenarios: Array<Scenario>;
  total: number;
  pagination: PaginationState;
  onPaginationChange: OnChangeFn<PaginationState>;
  sorting: SortingState;
  onSortingChange: OnChangeFn<SortingState>;
  onClickRow: (row: Row<Scenario>) => void;
}

const ScenariosTable: FC<ScenariosTableProps> = ({
  scenarios,
  total,
  pagination,
  onPaginationChange,
  sorting,
  onSortingChange,
  onClickRow,
}) => {
  const columns = useScenariosTableColumns();
  const table = useReactTable<Scenario>({
    state: {
      pagination,
      sorting,
    },
    getRowId: (row) => row.id,
    data: scenarios,
    columns,
    getCoreRowModel: getCoreRowModel(),
    manualPagination: true,
    manualSorting: true,
    enableSortingRemoval: false,
    enableMultiSort: false,
    onPaginationChange,
    onSortingChange,
    pageCount: Math.ceil(total / pagination.pageSize),
  });
  return (
    <DataTable
      className='w-full'
      table={table}
      onRowClick={onClickRow}
    />
  );
};
export default ScenariosTable;
